import { DatePicker } from "antd";
import locale from "antd/es/date-picker/locale/ru_RU";
import dayjs from "dayjs";
import "dayjs/locale/ru";
import { FC } from "react";
const { RangePicker } = DatePicker;

type CustomDatePickerProps = {
  values: string[];
  setValues: (values: string[]) => void;
  pickerType?: "time" | "date" | "week" | "month" | "quarter" | "year";
};

export const CustomDatePicker: FC<CustomDatePickerProps> = ({
  values = [],
  setValues,
  pickerType = "date",
}) => {
  const handleChange = (value: [string, string]) => {
    setValues(value);
  };

  const dateType = "DD-MM-YYYY";

  return (
    <RangePicker
      data-testid={`test-rangePicker`}
      defaultValue={
        values.length > 1 && !!values[0] && !!values[1]
          ? [dayjs(values[0], dateType), dayjs(values[1], dateType)]
          : undefined
      }
      format={dateType}
      locale={locale}
      onChange={(_: undefined, info: [string, string]) => {
        handleChange(info);
      }}
      allowClear={false}
      picker={pickerType}
    />
  );
};
